import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createIntegrationsSlice } from './actions';
import { IntegrationsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const partializeIntegrationsState = (state: IntegrationsStore) => {
  // teamGithubInstallationRequests is server-authoritative and not team-scoped in
  // the cache: rehydrating it would show one team's pending org on another.
  // currentEmailFilters is derived at runtime; a persisted one is a stale filter from the last session.
  const {
    isLoading,
    isDraftSaving,
    teamGithubInstallationRequests,
    currentEmailFilters,
    ...rest
  } = state;
  return rest;
};

export const mergeHydratedIntegrationsState = (
  persisted: unknown,
  current: IntegrationsStore,
): IntegrationsStore => ({
  ...current,
  ...(persisted as Partial<IntegrationsStore>),
  currentEmailFilters: current.currentEmailFilters,
});

export const useIntegrationsStore = create<IntegrationsStore>()(
  persist(
    (set, get, store) => ({
      ...createIntegrationsSlice(set, get, store),
    }),
    {
      name: ZustandStores.INTEGRATIONS,
      partialize: partializeIntegrationsState,
      merge: mergeHydratedIntegrationsState,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
